import { useQuery } from '@tanstack/react-query';
import { ResponseError } from 'superagent';
import { ApiClient } from 'src/client/helpers';
import urls, { constructUrl } from 'src/shared/urls';
import type { SiteProductsPPS } from 'src/@types/ProcessedPPSPriceGroup';

const galleryPricesFetcher = (type: string) =>
  new ApiClient().get(constructUrl(`${urls.get.galleryPrices}?type=${type}`)).then((res) => res.body);

export const useGalleryPrices = (type: string) => {
  const { data, isLoading } = useQuery<SiteProductsPPS, ResponseError>({
    queryKey: ['gallery-prices', type],
    queryFn: () => galleryPricesFetcher(type),
    staleTime: 10 * 60 * 1000, // 10 minutes before invalidation happens
  });

  return { isLoading, products: data?.products || [] };
};
